module.exports = __webpack_public_path__ + "static/media/fruita-crash.2b6adda1.jpg";